import { render, staticRenderFns } from "./carSelectCourse.vue?vue&type=template&id=b2067aac&scoped=true&"
import script from "./carSelectCourse.vue?vue&type=script&lang=js&"
export * from "./carSelectCourse.vue?vue&type=script&lang=js&"
import style0 from "./carSelectCourse.vue?vue&type=style&index=0&id=b2067aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2067aac",
  null
  
)

export default component.exports